export default __webpack_public_path__ + "static/media/broadnet_payment.afa7821b.png";